import { Link } from 'react-router-dom';
import './MentorCard.css';

const SPORT_EMOJIS = {
  'Basketball': '🏀',
  'Football': '🏈',
  'Soccer': '⚽',
  'Baseball/Softball': '⚾',
  'Tennis': '🎾',
  'Volleyball': '🏐',
  'Wrestling': '🤼',
  'Golf': '⛳',
};

function MentorCard({ mentor }) {
  const initials = `${mentor.first_name?.[0] || ''}${mentor.last_name?.[0] || ''}`.toUpperCase();

  const sports = [mentor.sport, mentor.secondary_sport].filter(Boolean);

  const focusAreas = mentor.focus_areas || [];
  const visibleTags = focusAreas.slice(0, 3);
  const overflowCount = focusAreas.length - 3;

  return (
    <div className="mentor-card">

      {/* Photo */}
      <div className="mentor-card-photo-wrap">
        {mentor.avatar_url ? (
          <img
            src={mentor.avatar_url}
            alt={`${mentor.first_name} ${mentor.last_name}`}
            className="mentor-card-photo"
          />
        ) : (
          <div className="mentor-card-photo-placeholder">
            {initials}
          </div>
        )}
      </div>

      {/* Body */}
      <div className="mentor-card-body">

        {/* Section 1: Name + location + grad year */}
        <div className="mentor-card-sec1">
          <h3 className="mentor-card-name">{mentor.first_name} {mentor.last_name}</h3>

          {(mentor.city || mentor.state) && (
            <div className="mentor-card-location-row">
              <i className="ti ti-map-pin" aria-hidden="true"></i>
              <span className="mentor-card-location-text">{[mentor.city, mentor.state].filter(Boolean).join(', ')}</span>
            </div>
          )}

          {mentor.grad_year && (
            <div className="mentor-card-school-row">
              <i className="ti ti-school" aria-hidden="true"></i>
              <span>Class of {mentor.grad_year}</span>
            </div>
          )}
        </div>

        <div className="mentor-card-divider" />

        {/* Section 2: Sports + focus areas */}
        <div className="mentor-card-sec2">
          {sports.map((sport) => (
            <div key={sport} className="mentor-card-sport-row">
              <span className="mentor-card-sport-emoji">{SPORT_EMOJIS[sport] || '🏅'}</span>
              <span className="mentor-card-sport-name">{sport}</span>
            </div>
          ))}

          {focusAreas.length > 0 && (
            <div className="mentor-card-focus-areas">
              {visibleTags.map((area) => (
                <span key={area} className="mentor-card-focus-tag">{area}</span>
              ))}
              {overflowCount > 0 && (
                <span className="mentor-card-focus-overflow">+{overflowCount}</span>
              )}
            </div>
          )}
        </div>

        <div className="mentor-card-divider" />

        {/* Section 3: Rate + stars + view button */}
        <div className="mentor-card-sec3">
          <div>
            <div className="mentor-card-rate">
              ${mentor.hourly_rate || 0}/hr
            </div>
            <div className="mentor-card-stars">
              {[1, 2, 3, 4, 5].map((i) => (
                <span
                  key={i}
                  className={`star ${i <= Math.round(mentor.avg_rating || 0) ? 'filled' : 'empty'}`}
                >
                  ★
                </span>
              ))}
              <span className="mentor-card-rating-count">
                ({mentor.rating_count || 0})
              </span>
            </div>
          </div>

          <Link to={`/mentors/${mentor.id}`} className="btn btn-primary">
            View
          </Link>
        </div>

      </div>
    </div>
  );
}

export default MentorCard;
